import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { setProductSearchQuery } from "@/lib/redux/productSearch/productSearchSlice";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
import { Button, CloseIcon, Container, Input } from "./styles";

export type SearchViewProps = {
  closeSearch: () => void;
};

const SearchView: React.FC<SearchViewProps> = (props) => {
  const { closeSearch } = props;
  const query = useAppSelector((state) => state.productSearch.query);
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  const { locale = "it" } = useRouter();
  const placeholder = useTranslation(
    "productListing.searchPlaceholder",
    locale
  );

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Container>
      <Input
        ref={inputRef}
        placeholder={placeholder || "Inserisci il codice prodotto"}
        value={query}
        onChange={(event) => {
          const query = event.target.value;
          dispatch(setProductSearchQuery(query));
        }}
        onBlur={() => {
          if (!query) closeSearch();
        }}
      />
      <Button
        onClick={() => {
          dispatch(setProductSearchQuery(""));
          closeSearch();
        }}
      >
        <CloseIcon />
      </Button>
    </Container>
  );
};

export default SearchView;
